import assetDepartmentService from "../../../../services/assetService/assetDepartmentService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETDEPARTMENTS } from "../../../../utils/constants";
import { AssetDepartmentInterface } from "../../../../models/AssetModel/AssetDepartment";

interface AddAssetDepartmentContext {
  previousAssetDepartment: AssetDepartmentInterface[];
}

const useAddAssetDepartment = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetDepartmentInterface,
    Error,
    AssetDepartmentInterface,
    AddAssetDepartmentContext
  >({
    mutationFn: assetDepartmentService.Save,

    onMutate: () => {
      const previousAssetDepartment =
        queryClient.getQueryData<AssetDepartmentInterface[]>([
          CACHE_KEY_ASSETDEPARTMENTS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousAssetDepartment };
    },

    onSuccess: (savedAssetDepartment) => {
      queryClient.setQueryData<AssetDepartmentInterface[]>(
        [
          CACHE_KEY_ASSETDEPARTMENTS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (assetDepartment) =>
          assetDepartment
            ? [savedAssetDepartment, ...assetDepartment]
            : [savedAssetDepartment]
      );
    },

    onError: (error, newAssetDepartment, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetDepartmentInterface[]>(
        [
          CACHE_KEY_ASSETDEPARTMENTS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetDepartment
      );
    },
  });
};

export default useAddAssetDepartment;
